// ---------- Name Matching Core ---------------------------------------------

function matchContacts(query, contacts, options) {
  options = options || {};
  var minScore = options.minScore != null ? options.minScore : 0.82;
  var requireTwoTokens = options.requireTwoTokens != null ? options.requireTwoTokens : true;
  var maxResults = options.maxResults != null ? options.maxResults : 25;

  var q = normalizeName(query);
  var qTokens = tokensFrom(q);
  var qName = parsePersonLike(q);

  var results = [];
  for (var i = 0; i < contacts.length; i++) {
    var contact = contacts[i];
    var cForms = buildContactNameForms(contact);
    var best = { score: 0, matchedOn: null, explanation: "", passesGate: false };

    for (var j = 0; j < cForms.length; j++) {
      var s = scoreQueryAgainstCandidate(qName, qTokens, cForms[j]);
      if (s.score > best.score) best = s;
    }

    if (best.score >= minScore) {
      if (!requireTwoTokens || best.passesGate) {
        results.push({
          contact: contact,
          score: round2(best.score),
          matchedOn: best.matchedOn,
          explanation: best.explanation
        });
      }
    }
  }

  results.sort(function(a, b) { return b.score - a.score; });
  return results.slice(0, maxResults);
}

// ---------- Helpers ---------------------------------------------------------

var COMPANY_WORDS = {
  "llc":1,"inc":1,"incorporated":1,"corp":1,"corporation":1,"co":1,"company":1,
  "lp":1,"llp":1,"pllc":1,"plc":1,"partners":1,"partnership":1,"holdings":1,
  "group":1,"trust":1,"revocable":1,"family":1,"living":1,"ua":1,"u/a":1,
  "dated":1,"estate":1,"properties":1,"realty":1,"investments":1
};

var SURNAME_PARTICLES = {
  "de":1,"del":1,"la":1,"las":1,"los":1,"da":1,"do":1,"dos":1,"van":1,"von":1,
  "der":1,"den":1,"ter":1,"bin":1,"al":1,"el":1,"le":1,"di":1,"du":1,"st":1,
  "st.":1,"san":1,"santa":1
};

function normalizeName(str) {
  if (!str) return "";
  return String(str)
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[.,]/g, " ")
    .replace(/[–—-]/g, " ")
    .replace(/&/g, " and ")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

function tokensFrom(str) {
  return str ? str.split(/\s+/).filter(function(t){ return t.length > 0; }) : [];
}

function isCompanyish(str) {
  var t = tokensFrom(str);
  var hit = 0;
  for (var i = 0; i < t.length; i++) if (COMPANY_WORDS[t[i]]) hit++;
  return hit > 0 && t.length <= 5;
}

function stripCompanyNoiseTokens(tokens) {
  var out = [];
  for (var i = 0; i < tokens.length; i++) {
    if (!COMPANY_WORDS[tokens[i]]) out.push(tokens[i]);
  }
  return out;
}

function extractLastFromTokens(tokens) {
  if (!tokens.length) return { last: "", rest: [] };
  var i = tokens.length - 1;
  var parts = [tokens[i]];
  i--;
  while (i >= 0 && SURNAME_PARTICLES[tokens[i]]) {
    parts.unshift(tokens[i]);
    i--;
  }
  return { last: parts.join(" "), rest: tokens.slice(0, i+1) };
}

function parsePersonLike(raw) {
  var str = normalizeName(raw);
  var tokens = stripCompanyNoiseTokens(tokensFrom(str));
  var coupleSplit = splitCoupleTokens(tokens);
  if (coupleSplit) {
    var multi = [];
    for (var i = 0; i < coupleSplit.length; i++) {
      multi.push(parseSinglePersonTokens(coupleSplit[i]));
    }
    return { multi: multi, tokens: tokens };
  }
  return parseSinglePersonTokens(tokens);
}

function splitCoupleTokens(tokens) {
  var idx = tokens.indexOf("and");
  if (idx === -1) return null;
  var obj = extractLastFromTokens(tokens);
  var sharedLast = obj.last;
  var rest = obj.rest;

  var split = [];
  var cur = [];
  for (var i = 0; i < rest.length; i++) {
    var t = rest[i];
    if (t === "and") {
      if (cur.length) { split.push(cur); cur = []; }
    } else cur.push(t);
  }
  if (cur.length) split.push(cur);

  if (split.length >= 2) {
    var result = [];
    for (var s = 0; s < split.length; s++) {
      var arr = split[s].concat(sharedLast ? sharedLast.split(" ") : []);
      result.push(arr);
    }
    return result;
  }
  return null;
}

function parseSinglePersonTokens(tokens) {
  if (!tokens.length) return { first:"", middle:[], last:"", tokens:[] };
  var obj = extractLastFromTokens(tokens);
  var last = obj.last;
  var rest = obj.rest;
  var first = rest.length ? rest[0] : "";
  var middle = rest.length > 1 ? rest.slice(1) : [];
  return { first:first, middle:middle, last:last, tokens:tokens };
}

function buildContactNameForms(contact) {
  var forms = [];
  var first = normalizeName(contact.firstName || "");
  var last  = normalizeName(contact.lastName || "");

  if (first || last) {
    var joined = [contact.firstName, contact.middleName, contact.lastName]
      .filter(function(x){ return !!x; }).join(" ");
    var tok = stripCompanyNoiseTokens(tokensFrom(normalizeName(joined)));
    forms.push(parseSinglePersonTokens(tok));
    forms[forms.length-1].label = "person";
  }

  if (contact.company) {
    var compNorm = normalizeName(contact.company);
    var compTok = stripCompanyNoiseTokens(tokensFrom(compNorm));
    var asPerson = parsePersonLike(compNorm);
    if (asPerson.multi) {
      for (var i = 0; i < asPerson.multi.length; i++) {
        var f = asPerson.multi[i];
        f.label = "company-couple";
        forms.push(f);
      }
    } else {
      var p = parseSinglePersonTokens(compTok);
      var looksHuman = compTok.length >= 2 || (!isCompanyish(compNorm) && compTok.length >= 1);
      if (looksHuman) {
        p.label = "company-as-person";
        forms.push(p);
      }
    }
    var fullForm = { first:"", middle:[], last:"", tokens:tokensFrom(compNorm), label:"company-full" };
    forms.push(fullForm);
  }

  // Deduplicate by key
  var seen = {};
  var unique = [];
  for (var i = 0; i < forms.length; i++) {
    var f = forms[i];
    var key = f.label + "|" + f.tokens.join(" ");
    if (!seen[key]) { seen[key] = true; unique.push(f); }
  }
  return unique;
}

// --- Similarity primitives (Jaro-Winkler, etc.) ----------------------------

function jaroWinkler(a, b) {
  if (a === b) return 1;
  if (!a.length || !b.length) return 0;
  var m = Math.floor(Math.max(a.length, b.length) / 2) - 1;
  var aMatches = new Array(a.length);
  var bMatches = new Array(b.length);
  for (var i=0;i<aMatches.length;i++) aMatches[i]=false;
  for (var j=0;j<bMatches.length;j++) bMatches[j]=false;
  var matches = 0;

  for (var i = 0; i < a.length; i++) {
    var start = Math.max(0, i - m);
    var end   = Math.min(i + m + 1, b.length);
    for (var k = start; k < end; k++) {
      if (bMatches[k]) continue;
      if (a[i] !== b[k]) continue;
      aMatches[i] = true;
      bMatches[k] = true;
      matches++;
      break;
    }
  }
  if (!matches) return 0;

  var k2 = 0, transpositions = 0;
  for (var i = 0; i < a.length; i++) {
    if (!aMatches[i]) continue;
    while (!bMatches[k2]) k2++;
    if (a[i] !== b[k2]) transpositions++;
    k2++;
  }
  transpositions /= 2;
  var jaro = (matches / a.length + matches / b.length + (matches - transpositions) / matches) / 3;

  var prefix = 0;
  for (; prefix < Math.min(4, a.length, b.length) && a[prefix] === b[prefix]; prefix++);
  return jaro + prefix * 0.1 * (1 - jaro);
}

function tokenStrongMatch(t1, t2) {
  if (t1 === t2) return true;
  if (t1.length <= 2 || t2.length <= 2) return t1[0] === t2[0] && t1.length === 1 && t2.length === 1;
  return jaroWinkler(t1, t2) >= 0.93;
}

function countStrongOverlaps(aTokens, bTokens) {
  var count = 0;
  var used = {};
  for (var i = 0; i < aTokens.length; i++) {
    var a = aTokens[i];
    for (var j = 0; j < bTokens.length; j++) {
      if (used[j]) continue;
      if (tokenStrongMatch(a, bTokens[j])) {
        used[j] = true;
        count++;
        break;
      }
    }
  }
  return count;
}

function initialsMatch(a, b) {
  return a && b && a[0] === b[0];
}

function scoreQueryAgainstCandidate(qName, qTokens, cand) {
  var cTokens = cand.tokens;
  var qJoined = qTokens.join(" ");
  var cJoined = cTokens.join(" ");
  var jwFull = jaroWinkler(qJoined, cJoined);

  var qCore = cand.label && cand.label.indexOf("company") === 0 ? qTokens : stripCompanyNoiseTokens(qTokens);
  var cCore = cand.label && cand.label.indexOf("company") === 0 ? cTokens : stripCompanyNoiseTokens(cTokens);
  var strongOverlap = countStrongOverlaps(qCore, cCore);

  var score = jwFull;
  var passesGate = false;
  var reasons = [];

  if (cand.label && cand.label.indexOf("company") === 0) {
    if (jwFull >= 0.90 || strongOverlap >= Math.min(qCore.length, cCore.length)) {
      passesGate = true;
    }
    if (jwFull >= 0.96) reasons.push("company name ~exact");
    else if (jwFull >= 0.90) reasons.push("company name close");
    if (strongOverlap >= 2) reasons.push(strongOverlap + " token overlaps");
  } else {
    var qFirst = qName.first || (qName.multi ? qName.multi[0].first : "") || "";
    var qLast  = qName.last  || (qName.multi ? qName.multi[0].last  : "") || "";
    var cFirst = cand.first || "";
    var cLast  = cand.last  || "";

    var firstSim = qFirst && cFirst ? jaroWinkler(qFirst, cFirst) : 0;
    var lastSim  = qLast  && cLast  ? jaroWinkler(qLast,  cLast ) : 0;
    var firstInitOk = initialsMatch(qFirst, cFirst);

    var hasTwoTokens = strongOverlap >= 2;
    var lastPlusFirstOk = lastSim >= 0.92 && (firstInitOk || firstSim >= 0.88);
    var fullVeryClose = jwFull >= 0.90 && qTokens.length >= 2 && cTokens.length >= 2;
    passesGate = hasTwoTokens || lastPlusFirstOk || fullVeryClose;

    score = 0.40 * jwFull +
      0.25 * lastSim +
      0.20 * firstSim +
      0.15 * (strongOverlap / Math.max(2, Math.min(qTokens.length, cTokens.length)));

    if (firstInitOk && lastSim >= 0.92) score += 0.05;
    if (hasTwoTokens) score += Math.min(0.04 * (strongOverlap - 2), 0.06);

    if (lastSim >= 0.96) reasons.push("last name ~exact");
    else if (lastSim >= 0.90) reasons.push("last name close");
    if (firstSim >= 0.94) reasons.push("first name ~exact");
    else if (firstInitOk) reasons.push("first initial matches");
    if (hasTwoTokens) reasons.push(strongOverlap + " token overlaps");
    if (!cand.first && cand.label && cand.label.indexOf("company") === 0) reasons.push("matched via company name");
  }

  return {
    score: Math.max(0, Math.min(1, score)),
    passesGate: passesGate,
    matchedOn: cand.label,
    explanation: reasons.join("; ") || "overall similarity"
  };
}

function round2(n) {
  return Math.round(n * 100) / 100;
}

export default matchContacts;



// WEBPACK FOOTER //
// ./client/app/e-form/opt-in/name-matching.js